/**
 * @file ページパラメーター追加
 *
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname AddSearchParameters2
 * @classdesc ソートパラメーター追加
 */
export default class AddSearchParameters2 {
	/**
	 * @constructor
	 * @param {jQuery} $e - .pagination__item__link
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		if($e.parent().hasClass('active')){
			$e.attr('javascript:void(0);');
		}else{
			let url = Common.getCurrentURL();
			const params = Common.getParam();
			let parameters = ''
			let page = $e.data('page');
			if(page === '1') page = null;
			let prefix = '?';
			for(let key in params){
				if(key !== 'page') {
					parameters += `${prefix}${key}=${params[key]}`;
					prefix = '&';
				}
			}
			let href = `${url}${parameters}`;
			if(page){
				href += `${prefix}page=${page}`;
			}
			$e.attr('href', href);
		}
	};
};
